import { getSupplierGenericProperties } from '@bridebook/web/app-basic/lib/analytics/helper';
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { getSupplier, getSupplierTier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import Router from 'next/router';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import SocialBarComp from '@bridebook/web/app-shared/components/supplier/sections/social-bar/social-bar';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

const SocialBar = () => {
  const supplier = useSelector(getSupplier);
  const isMobile = useSelector(getIsMobile);
  const supplierTier = useSelector(getSupplierTier);
  const dispatch = useDispatch();

  const supplierGenericProps = useMemo(
    () => getSupplierGenericProperties({ supplier, supplierTier }),
    [supplier, supplierTier],
  );

  const onClick = useCallback(
    (e: React.MouseEvent<React.ReactNode | Element>, title: string) => {
      if (!supplier) return null;
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'supplierProfile',
          clickedSection: 'supplierSocialMedia',
          cta: title,
          ...supplierGenericProps,
        }),
      );
      e.preventDefault();
      Router.push(UrlHelper.signup);
    },
    [dispatch, supplier, supplierGenericProps],
  );

  if (!supplier) return null;
  return (
    <SocialBarComp
      supplier={supplier}
      isShareButtonEnabled={false}
      isMobile={isMobile}
      isVisitWebsiteCTAEnabled={false}
      onWebsiteClick={onClick}
      onSocialClick={onClick}
    />
  );
};

export default SocialBar;
